import React, { Component } from 'react';
import { HashRouter, Route } from 'react-router-dom';
import labels from './portals/constant/labels';

// Styling
import '../src/styling/global.css';

import MainContainer from './portals/Components/MainContainer/MainContainer.js';
import LandingPage from './portals/Page/LandingPage/LandingPage';
import Header from './portals/common/Header/Header';


class App extends Component {
    componentDidMount() {
        document.title = labels.TITLE;
    }

    render() {
        return (
            <HashRouter>
                <div className="App ">
                    <Header />
                    <Route exact path="/">
                        <LandingPage />
                    </Route>
                    <Route path="/track">
                        <MainContainer />
                    </Route>
                </div>
            </HashRouter>
        )
    }
}

export default App;
